import { OrderType } from 'types/orders/enums';
/** What `/orders/create` resolves to when the URL names no order type. */
export var DEFAULT_ORDER_TYPE = OrderType.SubscriptionNew;
/**
 * The order type a URL names. Stored values are used verbatim, so there is no spelling to keep in
 * sync. `undefined` for anything no order type owns — the caller redirects rather than guessing.
 */
export var getOrderTypeFromParam = function getOrderTypeFromParam(value) {
    return Object.values(OrderType).find(function (orderType) {
        return orderType === value;
    });
};
